import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {FocusTrapModule} from 'primeng/focustrap';
import {MultiSelectModule} from 'primeng/multiselect';
import {TextareaModule} from 'primeng/textarea';
import {MarketplaceCardComponent} from './marketplace-card.component';
import {MarketplaceComponent} from './marketplace.component';
import {MarketplaceContentComponent} from './marketplace-content.component';
import {ProgressSpinner} from "primeng/progressspinner";

@NgModule({
    declarations: [
        MarketplaceCardComponent,
        MarketplaceComponent,
        MarketplaceContentComponent
    ],
    imports: [
        ButtonModule,
        CommonModule,
        DialogModule,
        FocusTrapModule,
        FontAwesomeModule,
        FormsModule,
        MultiSelectModule,
        TextareaModule,
        ProgressSpinner
    ],
    exports: [
        MarketplaceComponent
    ]
})
export class MarketplaceModule { }
